import React, { useEffect } from 'react';
import { wrapConsumer } from '../FilteringContextProvider';
import {dbFieldType, defaultFilterColumn, userDefaultFilterPropHiddenValue} from '../../../constants';
import { history } from '../../../store';

const DefaultFilterHandler = ({
  handleApplyFiltering,
  handleFilterStateChanged,
  filterProps,
  userDefaultFilterProp,
  chemicalProductTitleDetails,
  user
}) => {
  useEffect(() => {
    const cpTrdChemNameUrl = new URLSearchParams(window.location.search).get(
      'GEN_TRADE_CHEMICAL_NAMES'
    );

    let defaultCols = userDefaultFilterProp || [];
    let isTradeName = defaultCols.includes(defaultFilterColumn.GEN_TRADE_CHEMICAL_NAMES);
    let histIsDeleted = defaultCols.includes(defaultFilterColumn.HIST_IS_DELETED);
    if (defaultCols !== undefined && defaultCols != null && defaultCols.length > 0) {
      let visibleFieldsTmp = filterProps.visibleFieldsList;
      let visibleColumnsListTmp = filterProps.visibleColumnsList;

      if (!histIsDeleted) {
        let field = filterProps.possibleFieldsList.find(obj => defaultCols.includes(obj.key));
        let column = filterProps.possibleColumnsList.find(
          obj => defaultCols.includes(obj.key) || (isTradeName && obj.key === 'GEN_TRADE_NAME')
        );
        if (!visibleFieldsTmp.find(obj => defaultCols.includes(obj.key))) {
          visibleFieldsTmp.push(field);
        }
        if (
          !visibleColumnsListTmp.find(
            obj => defaultCols.includes(obj.key) || (isTradeName && obj.key === 'GEN_TRADE_NAME')
          )
        ) {
          visibleColumnsListTmp.push(column);
        }
      }
      handleFilterStateChanged({
        visibleFields: visibleFieldsTmp,
        visibleColumns: visibleColumnsListTmp,
        dataViewId: -1
      });

      const filterStateObj = {};
      if (userDefaultFilterProp.includes(defaultFilterColumn.GEN_CONTACTS)) {
        filterStateObj.GEN_CONTACTS = [{ label: user.fullName, value: user.fullName }]
      } if (userDefaultFilterProp.includes(defaultFilterColumn.GEN_IS_CHECK_VALID)) {
        filterStateObj.GEN_IS_CHECK_VALID = dbFieldType.false
      } if (userDefaultFilterProp.includes(defaultFilterColumn.GEN_ORG_UNIT)) {
        let departs = Array.from(new Set([...user?.departments]));
        filterStateObj.GEN_ORG_UNIT = departs.map(dep => ({ label: dep, value: dep }));
      } if (userDefaultFilterProp.includes(defaultFilterColumn.GEN_LOCATION_NAME)) {
        filterStateObj.GEN_LOCATION_NAME = user.buildings.map(bld => ({ label: bld, value: bld }));
      } if (userDefaultFilterProp.includes(defaultFilterColumn.GEN_TRADE_CHEMICAL_NAMES)) {
        let cpTrdChemName = cpTrdChemNameUrl
          ? cpTrdChemNameUrl
          : chemicalProductTitleDetails.tradeName +
            (chemicalProductTitleDetails.chemicalName
              ? ', ' + chemicalProductTitleDetails.chemicalName
              : '');
        filterStateObj.GEN_TRADE_CHEMICAL_NAMES = [{ label: cpTrdChemName, value: cpTrdChemName }]
        //clear, otherwise custom dataviews can be updated by accident
        setTimeout(() => {
          if (cpTrdChemNameUrl)
            window.history.replaceState(history.location.state, '', history.location.pathname);
        }, 2000);
      } if (userDefaultFilterProp.includes(defaultFilterColumn.HIST_IS_DELETED)) {
        filterStateObj.HIST_IS_DELETED = userDefaultFilterPropHiddenValue[userDefaultFilterProp]
      }
      handleApplyFiltering(filterStateObj);
    }
  }, []);

  return null;
};

export default wrapConsumer(DefaultFilterHandler);
